import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { FaSearchPlus, FaLink } from "react-icons/fa";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import { useNavigate } from "react-router-dom";

const SearchListingLink = () => {
  const [show, setShow] = useState(false);
  const [fullUrl, setFullUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
    setFullUrl("");
    setLoading(false);
  };

  const handleShow = (e) => {
    e.preventDefault();
    setShow(true);
  };

  const handleSearch = async () => {
    if (!fullUrl) return;

    setLoading(true);

    // --- Slug Extraction Logic ---
    // This looks for the part after "/product/"
    let slug = "";
    try {
      if (fullUrl.includes("/product/")) {
        slug = fullUrl.split("/product/")[1].split("/")[0].split("?")[0];
      } else {
        // Fallback: if they just paste the slug itself
        slug = fullUrl.split("/").filter(Boolean).pop();
      }
    } catch (err) {
      slug = fullUrl; // Final fallback
    }

    try {
      // Sending ONLY the extracted slug to the backend
      const response = await axios.post(`${baseurl}searchListingBySlug`, {
        slug: slug.trim(),
      });

      if (response.data.success) {
        const listingId = response.data.data.id;
        navigate(`/admin/seller-listing-details/${listingId}`);
        handleClose();
      } else {
        alert("Listing not found for this slug.");
      }
    } catch (error) {
      console.error("Search Error:", error);
      alert("Error: Listing not found or server issue.");
    } finally {
      setLoading(false);
    }
  };

  // --- Styled UI Components ---
  const customStyles = `
    .slug-modal .modal-content {
      border: none;
      border-radius: 24px;
      box-shadow: 0 20px 50px rgba(0,0,0,0.1);
    }
    .url-box {
      background: #f1f4f9;
      border: 2px solid #e2e8f0;
      border-radius: 15px;
      padding: 12px 15px;
      transition: all 0.3s ease;
    }
    .url-box:focus-within {
      border-color: #3b82f6;
      background: #fff;
      box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
    }
    .url-input {
      border: none !important;
      background: transparent !important;
      box-shadow: none !important;
      font-size: 14px;
      color: #334155;
    }
    .btn-find {
      background: #2563eb;
      border: none;
      padding: 12px;
      border-radius: 12px;
      font-weight: 600;
      width: 100%;
      margin-top: 15px;
      transition: 0.2s;
    }
    .btn-find:hover {
      background: #1d4ed8;
      transform: translateY(-1px);
    }
  `;

  return (
    <>
      <style>{customStyles}</style>

      <button
        onClick={handleShow}
        className="btn btn-outline-primary d-flex align-items-center gap-2"
        style={{ borderRadius: "10px", padding: "8px 20px", fontWeight: "500" }}
      >
        <FaSearchPlus size={16} /> Search By Link
      </button>

      <Modal show={show} onHide={handleClose} centered className="slug-modal">
        <Modal.Header closeButton className="border-0 pt-4 px-4">
          <Modal.Title className="fw-bold">Search Product Link</Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 pb-4">
          <div className="mb-4">
            <p className="text-muted small">
              Paste the full product URL. We will automatically extract the slug for the search.
            </p>
          </div>

          <div className="url-box">
            <div className="d-flex align-items-center mb-1">
              <FaLink size={12} className="text-primary me-2" />
              <span className="text-uppercase fw-bold text-muted" style={{fontSize: '10px', letterSpacing: '1px'}}>Product URL</span>
            </div>
            <Form.Control
              type="text"
              placeholder="https://techsparesindia.com/product/..."
              className="url-input"
              value={fullUrl}
              onChange={(e) => setFullUrl(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
          </div>

          <Button 
            className="btn-find"
            onClick={handleSearch} 
            disabled={loading || !fullUrl}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Extract & Search"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SearchListingLink;